import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

import { ApiService } from "./api.service";
import { APIResults } from "./sharedinterfaces";


@Injectable()
export class FleetTrackerService {
	private router = inject(Router);
	private api = inject(ApiService);

	public fleets: BehaviorSubject<APIResults.Fleet[]> = new BehaviorSubject<APIResults.Fleet[]>(undefined);
	public currentFleet: BehaviorSubject<APIResults.Fleet | undefined> = new BehaviorSubject<APIResults.Fleet | undefined>(undefined);
	public currentAsset: BehaviorSubject<APIResults.FleetAsset | undefined> = new BehaviorSubject<APIResults.FleetAsset | undefined>(undefined);

	async Refresh(): Promise<void> {
		try {
			const fleets = await this.api.GetFleets();
			console.log("Updating fleets");
			this.fleets.next(fleets);
		} catch (err) {
			if (err && err.status === 401) {
				this.api.Logout();
				this.Clear();
				this.router.navigate(["/login"]);
			}
		}
		// TODO: Error handling
	}

	Clear() {
		this.fleets.next(undefined);
		this.currentFleet.next(undefined);
		this.currentAsset.next(undefined);
	}

	SelectFleet(fleet_id: number): APIResults.Fleet | undefined {
		const fleet = this.GetFleet(fleet_id);
		this.currentFleet.next(fleet);
		return fleet;
	}

	GetFleet(fleet_id: number): APIResults.Fleet | undefined {
		const value = this.fleets.getValue();
		if (value && Array.isArray(value)) {
			const fleet = value.find(item => item.fleet_id === fleet_id);
			return fleet;
		}
		return undefined;
	}

	SelectAsset(asset_id: number) {
		this.currentAsset.next(this.GetAsset(asset_id));
	}

	GetAsset(asset_id: number): APIResults.FleetAsset | undefined {
		const fleetsvalue = this.fleets.getValue();
		if (fleetsvalue && Array.isArray(fleetsvalue)) {
			for (let i = 0; i < fleetsvalue.length; i++) {
				const assets = fleetsvalue[i].assets;
				if (assets) {
					const asset = assets.find(item => item.asset_id === asset_id);
					if (asset) {
						return asset;
					}
				}
			}
		}
		return undefined;
	}

}

